export default "__VITE_ASSET__Bcsi1ul___"